import {ChildAccount} from '../interfaces/childAccountResponse';
import {ChildAccountResponse} from '../interfaces/childAccountResponse';
import { AdminAccountService, DavisAlertService } from '@DavisDigital/davisdigitalfrontend.module';

class AdminAccountListingController {

	public accounts:Array<ChildAccount>;
	public stagedAccountIDs: { [key:string]: boolean } = {};
	public stagedAccountCount:number = 0;
	public showRemoveAllAccountButton = false;
	public showErrorMessage = false;
	public errorMessageString:string;
	public recordCount:number = 0;
	public currentPage = 1;
	public pageRecordShow = 20;
	public paginationOptions = [5,10,20,30];
	public accountRelationshipRoles: Array<any>;
	public appliedFilters = {};
	public selectedRoleID:string = "";	
	public lastName:string;	
	public firstName:string;	
	public userName:string;
	public emailAddress:string;
	public showAccountLockModal:boolean;
	public accountMap = {};
	public activeFlag = false;
	public adminController:any;
	public pageRole:string = "";
	public tagName:string;
	public loading:boolean = false;
	public importFiles: Array<{ fileName: string, fileID: string }>;
	public selectedImportfile: string;
	public allSelected: boolean = false;
	
	// @ngInject
	constructor(
		 private adminAccountService:AdminAccountService,
		 private davisAlertService:DavisAlertService,
		 private $location       : ng.ILocationService
	
	){}
	
	public $onInit = () => {
		
		this.pageRole = this.$location.search().role;
		//handle bad data
		this.pageRole = this.pageRole != "student" && this.pageRole != "teacher" ? "" : this.pageRole;
		
		this.getInitData(); //todo - probably better to do this in one call
	}
	public getAllChildrenAccounts():void{
		this.getChildrenAccounts(this.currentPage, true);
	}
	
	private buildFiltersOnObject(obj): any {
		if(this.selectedRoleID){
			obj['accountRelationshipRoleID'] = this.selectedRoleID;
		}
		
		if(this.lastName){
			obj['lastName'] = this.lastName;
		}
		
		if(this.firstName){
			obj['firstName'] = this.firstName;
		}
		
		if(this.emailAddress){
			obj['emailAddress'] = this.emailAddress;
		}
		
		if(this.userName){
			obj['userName'] = this.userName;
		}
		
		if ( this.selectedImportfile ) {
			obj['importFile'] = this.selectedImportfile;
		}
		
		//always send active flag, need active account list by default
		obj['activeFlag'] = !this.activeFlag;
		
		if(this.tagName){
			obj['tagName'] = this.tagName;
		}
		
		return obj;
	}
	
	public getChildrenAccounts(currentPage = this.currentPage, selectAll = false):void{
		if((this.recordCount && this.pageRecordShow * currentPage >= this.recordCount + this.pageRecordShow ) || currentPage < 1){
			return;
		}
		
		let data = {};
		this.loading = true;
		
		data = this.buildFiltersOnObject(data);
		
		this.currentPage = currentPage; 
		if(this.pageRole=='student' || this.pageRole=='teacher') {
			selectAll = true;
		}
		
		
		this.adminAccountService.getChildrenAccounts(currentPage, this.pageRecordShow, 1, data, false).then( (res:ChildAccountResponse) =>{
			this.accounts = res.accounts || [];
			
			this.recordCount = typeof res.recordCount != 'undefined' ? res.recordCount : 0;
			for(let account of this.accounts){
				this.accountMap[account.accountID] = account;
			}
			//select all if any role is available
			if( this.pageRole != '' || selectAll) {
				this.stageAllUsers(false);
			}
			if(this.pageRole=='student' || this.pageRole=='teacher') {
				this.pre_bulkManageAccounts();
			}

		}).finally(()=>{
			this.loading = false;
		});
	}
	
	public resetFilters(): void {
		this.selectedRoleID = null;
		this.lastName = null;
		this.firstName = null;
		this.emailAddress = null;
		this.userName = null;
		this.selectedImportfile = null;
		this.activeFlag = false;
		this.tagName = null;
		this.getChildrenAccounts(this.currentPage, false);
	}
	
	//adds or removes accountID from staged accounts if the user is found or not
	public toggleAccountStagingStatus(accountID:ChildAccount['accountID']):void{
		if( this.stagedAccountIDs[accountID] !== undefined ) {
			if ( this.allSelected === true && this.stagedAccountIDs[accountID] === false ) {
				delete this.stagedAccountIDs[accountID];
			} else {
				this.stagedAccountIDs[accountID] = !this.stagedAccountIDs[accountID];
			}
		} else {
			this.stagedAccountIDs[accountID] = !this.allSelected;
		}
		this.setStagedAccountCount();
	}
	
	private setStagedAccountCount(): void {
		if ( this.allSelected ) {
			let negativeCount = Object.keys(this.stagedAccountIDs).filter(k => this.stagedAccountIDs[k] === false).length;
			this.stagedAccountCount = this.recordCount - negativeCount;
		} else {
			let positiveCount = Object.keys(this.stagedAccountIDs).filter(k => this.stagedAccountIDs[k] === true).length;
			this.stagedAccountCount = positiveCount;
		}
	}
	
	public stageAllUsers(pageOnly: boolean): void {
		this.allSelected = !pageOnly;
		this.stagedAccountIDs = {};
		if (pageOnly) {
			this.accounts.forEach(a => {
				this.stagedAccountIDs[a.accountID] = true;
			});
		}
		this.setStagedAccountCount();
		this.showRemoveAllAccountButton = true;
	}
	
	public unstageAllUsers():void{
		this.allSelected = false;
		this.stagedAccountIDs = {};
		this.stagedAccountCount = 0;
		this.showRemoveAllAccountButton = false;
	}
	
	//Common helper method to do bulk account check
	private pre_bulkCheckAccounts(lockAccount = false):boolean{
		if( !this.allSelected && !Object.keys( this.stagedAccountIDs ).length ){
			this.showErrorMessage = true;
			if(lockAccount){
				this.errorMessageString = 'Please select an account to ' + (this.activeFlag ? 'unlock' : 'lock');
			} else{
				this.errorMessageString = 'Please select an account to manage licenses';	
			}
			return false;
		}
		
		this.showErrorMessage = false;
		return true;
	}
	
	public pre_bulkLockAccounts(): void {
		this.showAccountLockModal = this.pre_bulkCheckAccounts(true);
	}
	
	/**
	 * Method to pass selected Accounts to admin controller
	*/
	public pre_bulkManageAccounts(): void {
		
		this.loading = true;
		if( this.pre_bulkCheckAccounts() ) {
			this.adminController.handlePermissionCallback( 
				Object.keys(this.stagedAccountIDs).filter(k => this.stagedAccountIDs[k] === !this.allSelected).join(),
				this.allSelected,
				this.buildFiltersOnObject( {} )
			);
		}
	}
	
	public bulkLockAccounts(): void {
		
		//ignore any race condition
		if( this.loading ) {
			return;
		}
		
		this.loading = true;
		
		this.adminAccountService.bulkLockAccounts( Object.keys(this.stagedAccountIDs).filter(k => this.stagedAccountIDs[k] === !this.allSelected).join(), this.activeFlag ? 1 : 0, this.allSelected ).then(res =>{
			if(res.data?.data?.success || res.data?.success){
				this.davisAlertService.success('Account status updated successfully. It may take few seconds to reflect the changes.');
				
				this.unstageAllUsers();
				this.getChildrenAccounts(1, false);
				
			}
			this.showAccountLockModal = false;
		}).finally( ()=>{
			this.loading = false;
		});
	}
	
	public getInitData():void{
		this.adminAccountService.getInitData().then(res => {
			if ( res.importFiles ) {
				this.importFiles = res.importFiles;
			}
			if(res.accountRelationshipRoles){
				this.accountRelationshipRoles = res.accountRelationshipRoles;
				
				//select default role
				if( this.selectedRoleID == "") {
					if( this.pageRole == "student") {
						for(var i=0; i<this.accountRelationshipRoles.length; i++){
							var role = this.accountRelationshipRoles[i];
							if(role['accountRelationshipRoleName'].toLowerCase() === 'student'){
								this.selectedRoleID = role['accountRelationshipRoleID'];
								break;
							}
						} 
					} else if( this.pageRole == "teacher") {
						for(var i=0; i<this.accountRelationshipRoles.length; i++){
							var role = this.accountRelationshipRoles[i];
							if(role['accountRelationshipRoleName'].toLowerCase() === 'faculty'){
								this.selectedRoleID = role['accountRelationshipRoleID'];
								break;
							}
						} 
					}
				}
				
				//get records
				this.getChildrenAccounts();
			}
		});
	}
}

class AdminAccountListing {
	public restrict: string = 'E';
	public templateUrl: string;
	public scope: boolean = true;
	
	public bindToController: any = {
		adminController: '='
	};

	public controller = AdminAccountListingController;
	public controllerAs = 'adminAccountListing';

	public static Factory() {
		var directive:any = ( davisFrontendBasePath ) => new this( davisFrontendBasePath );
		directive.$inject = ['davisFrontendBasePath'];
		return directive;
	}

	constructor(
		private davisFrontendBasePath
	) {
		this.templateUrl = davisFrontendBasePath + '/davisdigital/directives/admin-account-listing.html';
	}
}

export { AdminAccountListing };
